import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {CarouselModule} from 'ngx-owl-carousel-o';
import {TestimonialSliderContentComponent} from './testimonial-slider/testimonial-slider.component';
import {TestimonialContentComponent} from './testimonial-content/testimonial-content.component';


@NgModule({
	declarations: [
		TestimonialSliderContentComponent,
		TestimonialContentComponent
	],
	imports: [
		CommonModule,
		CarouselModule
	],
	exports: [
		TestimonialSliderContentComponent,
	]
})
export class TestimonialModule { }
